import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'type',
    'digitalFields',
    'embroideryFields',
    'screenFields',
  ];

  // The Dark upcharge section is both a `digitalFields` target and the print-type
  // controller's `noDarkChargeSection`. Showing the Digital fields must not reveal it on
  // its own: only a DTG print type offers the charge, and that controller decides.
  static DARK_SECTION_SELECTOR =
    '[data-digital-print-type-target="noDarkChargeSection"]';

  connect() {
    this.selectType();
  }

  selectType() {
    const type = this.typeTarget.value;

    // Several divs share each target name, so every one has to be toggled - using the
    // singular target left the others (the Dark upcharge section among them) visible and
    // submitting for the wrong discipline (86ak7x1kk).
    this.#toggleSection(this.digitalFieldsTargets, type === 'Digital');
    this.#toggleSection(this.embroideryFieldsTargets, type === 'Embroidery');
    this.#toggleSection(this.screenFieldsTargets, type === 'Screen');

    this.element.dispatchEvent(
      new CustomEvent('produceable-type:changed', {
        bubbles: true,
        detail: { type },
      })
    );
  }

  #toggleSection(sections, visible) {
    sections.forEach((section) => {
      // The Dark section is never shown by discipline alone; the print-type controller
      // re-enables it when DTG is chosen. Hiding it here is always correct.
      const isDarkSection = section.matches(
        this.constructor.DARK_SECTION_SELECTOR
      );
      const show = visible && !isDarkSection;

      section.classList.toggle('d-none', !show);
      // The print-type controller owns the Dark section's disabled state - it is the only
      // one that knows whether the print type offers the charge. Leaving it alone here
      // means the two controllers never race, rather than relying on Stimulus connecting
      // them in a particular order.
      if (isDarkSection) return;

      // `d-none` only hides: a hidden checkbox is still submitted, so disabling is what
      // actually keeps it out of the params.
      section.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.disabled = !show;
      });
    });
  }
}
